import tree from "../../../components/tree.vue"
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { emailRule,domainName } from '@/utility/index.js'

export default {
  name: "JurisdictionalCompanies",
  components: { tree, iTable, IPagination },
  data() {
    return {
      formInline: {
        companyNum: '',
        name: ''
      },
      dialogVisible: false,
      height: '550',
      list: [], 
      option: {
        stripe: true, 
        border: true,
        loading: false, 
        highlightCurrentRow: false, 
        mutiSelect: true, 
        serialNumber: true, 
      },
      columns: [
        {
          prop: "companyNum",
          label: this.$t('GovernmentRegulation.companyNum'),
          align: "center",
        },
        {
          prop: "name",
          label: this.$t('common.companyName'),
          align: "center",
        },
        {
          prop: "email",
          label: this.$t('GovernmentRegulation.email'),
          align: "center",
        },
        {
          prop: "companyAddress",
          label: this.$t('GovernmentRegulation.companyAddress'),
          align: "center",
        }
      ],
      operates: {
        width: 60,
        fixed: "right",
        list: [
        ],
      },
      currentPage: 1, 
      pageSize: 10, 
      total: 1, 

      dialogFormVisible: false,
      formLabelWidth: '140px',
      diaTitle: '',
      btnType: '',
      rules: {
        companyNum: [
          { required: true, message: this.$t('GovernmentRegulation.companyNum'), trigger: 'blur' },
        ],
      },
      form: {
        companyNum: '',
        name: '',
      },
      selected: [],

      dialogBatchFormVisible: false,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.name = this.$route.params.name
    }
  },
  mounted() {
    this.getJurisdictional()
  },
  methods: {
    getJurisdictional() {
      let param = {
        jurisdictionNum: sessionStorage.getItem('jurisdictionNum'),
        companyNum: this.formInline.companyNum,
        name: this.formInline.name,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.$store.dispatch('JurisdictionalCompanies/GET_GETJURISDICTIONCOMPANY', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      })
    },
    onSearch() {
      this.currentPage = 1
      this.getJurisdictional()
    },
    onClear() {
      this.formInline = {
        companyNum: '',
        name: '',
      }
      this.getJurisdictional()
    },

    handleSelectionChange(val) {
      this.selected = val
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getJurisdictional();
    },
    addJurisdictional() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.add')
      this.btnType = 'add'
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            jurisdictionNum: sessionStorage.getItem('jurisdictionNum'),
            companyNum: this.form.companyNum,
            name: this.form.name,
          }
          if (this.btnType == 'add') {
            this.$store.dispatch('JurisdictionalCompanies/GET_ADDJURISDICTIONCOMPANY', param).then(res => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('common.btn.addSuccess'))
                this.dialogFormVisible = false;
                this.getJurisdictional();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }

            }).catch(err => { })
          }
        } else {
          return false;
        }
      });
    },
    cancle(formName) {
      this.dialogFormVisible = false;
      this.form = {
        companyNum: '',
        name: '',
      }
    },
    closeDia() {
      this.form = {
        companyNum: '',
        name: '',
      }
      this.dialogFormVisible = false;
    },
   
    deleteJurisdictional() {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
        {
          cancelButtonText: this.$t('common.btn.cancel'),
          confirmButtonText: this.$t('common.btn.confirm'),
          type: 'warning'
        }).then(res => {
          let param = { companyId: this.selected[0].id }
          this.$store.dispatch('JurisdictionalCompanies/GET_DELETEJURISDICTIONCOMPANY', param).then(response => {
            if (response.data.code == 200) {
              this.getJurisdictional()
              this.$message.success(this.$t('common.btn.deleteSuccess'))
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {

        })
    },

    BulkImport() {
        this.dialogBatchFormVisible = true
    },
    
    TemplateFile() {
        if (domainName) {
            if (domainName.split(':')[0] !== 'localhost') {
                let url = `https://${domainName}/v1/exportTemplate/exportJurisdictionCompanyTemplate`
                location.href = url
                
            } else {
                let host = 'localhost:8080'
                let url = `https://${host}/v1/exportTemplate/exportJurisdictionCompanyTemplate`
                location.href = url
                
            }
        }
    },
    
    uploadCar(e) {
        let dom = document.getElementById('uploadDom')
        let file = dom.files[0];
        let jurisdictionNum = sessionStorage.getItem('jurisdictionNum')
        let formData = new FormData()
        formData.append('File', file)
        formData.append('jurisdictionNum', jurisdictionNum)
        let types = file.name.split('.')[1]
        if (types != "xlsx" && types != "xls") {
            this.$message.error(this.$t('common.btn.choseExcelFile'));
            return false;
        } else {
            this.$store.dispatch('JurisdictionalCompanies/GET_UPLOADJURISDICTIONCOMPANY', formData).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                    this.dialogBatchFormVisible = false;
                    this.getJurisdictional()
                } else {
                    this.$message.error(res.data.msg)
                }
                document.getElementById('uploadDom').value = ''
            }).catch(err => {
                this.$message.error(this.$t('common.btn.fileUploadError'))
                document.getElementById('uploadDom').value = ''
            })
        }
    },
    closeBatchDia() {
        this.dialogBatchFormVisible = false
    },
    
  },
};
